const SESSION_KEY = 'kailani_chat'
const SESSION_TTL_MS = 30 * 60 * 1000

export function saveSession(state) {
  sessionStorage.setItem(SESSION_KEY, JSON.stringify({
    chatId: state.chatId,
    wasOpen: state.isOpen,
    messageCount: state.messageCount,
    lastSearchTs: state.lastSearchTs,
    lastActiveAt: Date.now()
  }))
}

// Has the guest just arrived, or are they still moving around the site?
//
// Property and navigation links carry data-turbo="false", so every click is a
// full page load and the chat is rebuilt each time. Without this the only
// thing distinguishing "clicked a home" from "came back tomorrow" was a 30
// minute timer, so a returning guest met Kailani mid-conversation with the
// greeting gone. Robert raised it as the first thing to fix about the chat.
//
// A same-origin referrer means they clicked through from one of our pages, so
// the conversation continues. Anything else, arriving from Google, a bookmark,
// a typed address, starts a new one.
function arrivedFromOurOwnSite() {
  const ref = document.referrer
  if (!ref) return false

  try {
    return new URL(ref).origin === window.location.origin
  } catch {
    return false
  }
}

export function restoreSession() {
  const saved = sessionStorage.getItem(SESSION_KEY)
  if (!saved) return null

  if (!arrivedFromOurOwnSite()) {
    clearSession()
    return null
  }

  try {
    const state = JSON.parse(saved)
    if (!state.chatId) return null

    const age = Date.now() - (state.lastActiveAt || 0)
    if (age > SESSION_TTL_MS) {
      sessionStorage.removeItem(SESSION_KEY)
      sessionStorage.removeItem('kailani_viewed')
      return null
    }

    return state
  } catch {
    sessionStorage.removeItem(SESSION_KEY)
    return null
  }
}

export function clearSession() {
  sessionStorage.removeItem(SESSION_KEY)
  sessionStorage.removeItem('kailani_viewed')
}

export function setSkipContext() {
  sessionStorage.setItem('kailani_skip_context', '1')
}

export function consumeSkipContext() {
  if (sessionStorage.getItem('kailani_skip_context')) {
    sessionStorage.removeItem('kailani_skip_context')
    return true
  }
  return false
}
